import React, { Component } from 'react';
import { SvgIcon } from '@mui/material';

const styles = {
  viewBoxStyle: '0 0 18 24',
  iconStyle: {
    width: 18,
    height: 24,
  },
};

class SubscribeIcon extends Component {
  render() {
    return (
      <SvgIcon viewBox={styles.viewBoxStyle} style={styles.iconStyle} {...this.props}>
        <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
          <g id="Frame" transform="translate(-34.000000, -378.000000)">
            <g id="Destinations" transform="translate(34.000000, 378.000000)">
              <path
                d="M9,18.7956364 C8.296884,18.7956364 7.725924,18.2189455 7.725924,17.5086909 L7.725924,1.61669091 C7.725924,0.906472727 8.296848,0.329745455 9,0.329745455 C9.703152,0.329745455 10.274076,0.906436364 10.274076,1.61669091 L10.274076,17.5086909 C10.274076,18.2189091 9.703152,18.7956364 9,18.7956364 Z"
                id="Fill-1"
              />
              <path
                d="M9,19.5810909 C8.485308,19.5810909 8.019828,19.2685891 7.82298,18.7870545 C7.6261032,18.3069455 7.7357916,17.7529455 8.0986032,17.3850545 L14.8543632,10.5610545 C15.3535752,10.0624727 16.1565552,10.0653091 16.6529592,10.5653164 C17.1479592,11.0667345 17.1493632,11.8778255 16.6571784,12.3806618 L9.9014184,19.2046618 C9.6623568,19.4461382 9.3375144,19.5825164 9.0000144,19.5810982 L9,19.5810909 Z"
                id="Fill-2"
              />
              <path
                d="M9,19.5810909 C8.6625,19.5825127 8.337672,19.4461491 8.098596,19.2046545 L1.342836,12.3806545 C0.84924,11.8778182 0.852048,11.0667273 1.3470552,10.5653091 C1.8434592,10.0638909 2.6464392,10.0624727 3.1442472,10.5610473 L9.9000072,17.3850473 L9.9014112,17.3850473 C10.2642192,17.7529382 10.3739112,18.3069382 10.1770344,18.7870473 C9.9801576,19.2685745 9.5147064,19.5810836 9.0000144,19.5810836 L9,19.5810909 Z"
                id="Fill-3"
              />
              <path
                d="M16.72452,23.6705455 L1.27548,23.6705455 C0.572364,23.6705455 0.002808,23.0938545 0.002808,22.3836 C0.002808,21.6719636 0.572328,21.0966545 1.27548,21.0966545 L16.72452,21.0966545 C17.427636,21.0966545 17.997192,21.6719273 17.997192,22.3836 C17.997192,23.0938182 17.427672,23.6705455 16.72452,23.6705455 Z"
                id="Fill-4"
              />
            </g>
          </g>
        </g>
      </SvgIcon>
    );
  }
}

export default SubscribeIcon;
